import { useEffect } from "react";
import { Features } from "@/components/sections/Features";
import { HowItWorks } from "@/components/sections/HowItWorks";
import { FinalCTA } from "@/components/sections/FinalCTA";

export default function FeaturesPage() {
  useEffect(() => {
    document.title = "Features — MACHA";
  }, []);

  return (
    <>
      <section className="border-b border-border bg-background">
        <div className="mx-auto w-full max-w-6xl px-5 py-20 text-center sm:px-8 sm:py-24">
          <p className="text-[11px] font-semibold uppercase tracking-[0.18em] text-primary">
            Features
          </p>
          <h1 className="mx-auto mt-3 max-w-2xl text-balance text-4xl font-semibold tracking-tight text-foreground sm:text-5xl">
            A quiet copilot for the loudest part of freelance work.
          </h1>
          <p className="mx-auto mt-4 max-w-xl text-base leading-relaxed text-muted-foreground">
            Six tools, one keyboard shortcut. Every one of them shaves a few
            minutes off every reply.
          </p>
        </div>
      </section>
      <Features />
      <HowItWorks />
      <FinalCTA />
    </>
  );
}
